import { useState, useEffect, useRef } from 'react';
import heroVideo from "../../../assets/video/hero-video.mp4";
import "./HomeSection.css";

function HomeSection() {
  const heroRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const currentRef = heroRef.current;

    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (entry.isIntersecting) {
          setIsVisible(true);
          if (currentRef) {
            observer.unobserve(currentRef);
          }
        }
      },
      { threshold: 0.3 }
    );

    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, []);

  return (
    <section className="hero" ref={heroRef}>
      <video className="hero-video" autoPlay loop muted playsInline>
        <source src={heroVideo} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <div className="hero-content">
        <h1 className={`hero-title ${isVisible ? 'animate' : ''}`}>
          Great Moments with Great Tastes
        </h1>
        <button
          className={`explore-button btn-link ${isVisible ? 'animate' : ''}`}
          onClick={() => window.location.href = "/menu"}
        >
          Explore Menu
        </button>
      </div>
    </section>
  )
}

export default HomeSection